import React from "react";
import styles from "./Highlight.module.scss";

interface HighlightProps {
	children?: React.ReactNode;
}

export const Highlight = ({ children }: HighlightProps) => {
	return <em className="highlight">{children}</em>;
};
